export default __webpack_public_path__ + "static/media/slack.044efd1b.svg";